// The blog's RSS 2.0 feed (`/blog/feed.xml`, src/routes/blog/feed[.]xml.ts), newest post first.
import { TITLE } from "shared/SharedConstants";
import type { BlogPostSummary } from "src/lib/BlogPosts";
import { SITE_URL } from "src/lib/Seo";

export const BLOG_FEED_PATH = "/blog/feed.xml";

const escapeXml = (value: string) =>
  value.replace(
    /[<>&'"]/g,
    (char) => `&${{ "<": "lt", ">": "gt", "&": "amp", "'": "apos", '"': "quot" }[char]};`,
  );

const absolute = (path: string) => new URL(path, SITE_URL).toString();

export const renderBlogFeed = (posts: readonly BlogPostSummary[]) => {
  const items = posts.map((post) => {
    const url = absolute(`/blog/${post.slug}`);
    return [
      "<item>",
      `<title>${escapeXml(post.title)}</title>`,
      `<link>${escapeXml(url)}</link>`,
      `<guid isPermaLink="true">${escapeXml(url)}</guid>`,
      `<description>${escapeXml(post.description)}</description>`,
      `<pubDate>${new Date(`${post.date}T00:00:00Z`).toUTCString()}</pubDate>`,
      ...post.tags.map((tag) => `<category>${escapeXml(tag)}</category>`),
      "</item>",
    ].join("\n");
  });
  return [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<rss version="2.0" xmlns:atom="http://www.w3.org/2005/Atom">',
    "<channel>",
    `<title>${escapeXml(`${TITLE} blog`)}</title>`,
    `<link>${escapeXml(absolute("/blog"))}</link>`,
    `<atom:link href="${escapeXml(absolute(BLOG_FEED_PATH))}" rel="self" type="application/rss+xml"/>`,
    `<description>${escapeXml(`Product updates and integration guides from the ${TITLE} team.`)}</description>`,
    "<language>en</language>",
    ...(posts[0]
      ? [`<lastBuildDate>${new Date(`${posts[0].date}T00:00:00Z`).toUTCString()}</lastBuildDate>`]
      : []),
    ...items,
    "</channel>",
    "</rss>",
    "",
  ].join("\n");
};
